module.exports = __webpack_public_path__ + "img/TermsConditions.3f89c908.svg";